import React from 'react';

const TermsConditions = () => {
  return (
    <div className="terms-conditions-container p-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
      <h6 className="text-center mb-4" style={{ fontSize: '18px' }}>Terms and Conditions</h6>

      <h6 className="mt-4" style={{ fontSize: '16px' }}>Definitions</h6>
      <div className="mb-4">
        <p style={{ fontSize: '14px' }}><strong >Buyer:</strong> A Buyer is an individual, organization, or government entity that:</p>
        <ul className="mb-3">
          <li style={{ fontSize: '14px' }}>Registers on the website to browse, evaluate, and purchase defense-related products or services.</li>
          <li style={{ fontSize: '14px' }}>May include but not limited to procurement officers, contractors, or authorized representatives or law enforcement agencies.</li>
          <li style={{ fontSize: '14px' }}>Is responsible for ensuring that purchases comply with applicable national and international laws, including export control regulations.</li>
        </ul>

        <p style={{ fontSize: '14px' }}><strong>Seller:</strong> A Seller is a verified vendor, manufacturer, or distributor who:</p>
        <ul>
          <li style={{ fontSize: '14px' }}>Registers and lists products or services on the platform.</li>
          <li style={{ fontSize: '14px' }}>Must comply with all legal, regulatory, and licensing requirements for the sale of equipment.</li>
          <li style={{ fontSize: '14px' }}>Is responsible for the accuracy of product descriptions, certifications, and delivery timelines.</li>
        </ul>
      </div>

      <h6 className="mt-4" style={{ fontSize: '16px' }}>Platform Terms and Conditions</h6>
      <ol className="mb-4">
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong >Acceptance of Terms:</strong> By accessing or using this platform, you agree to be bound by these Terms and Conditions. If you do not agree, you may not use the platform.
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Eligibility:</strong>
          <ul>
            <li>Buyers must be legally authorized to procure defense-related goods.</li>
            <li>Sellers must be licensed and compliant with all applicable trade regulations.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Account Registration</strong>
          <ul>
            <li>Users must provide accurate and complete information.</li>
            <li>The platform reserves the right to verify credentials and deny access if necessary.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Product Listings and Sales</strong>
          <ul>
            <li>Sellers are solely responsible for the accuracy of product descriptions, pricing, and compliance documentation.</li>
            <li>The platform does not guarantee the quality, legality, or delivery of listed products.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Compliance with Laws</strong>
          <ul>
            <li>All transactions must comply with, Export Administration Regulations (EAR), International Traffic in Arms Regulations (ITAR), and Local and international arms control laws.</li>
            <li>Buyers may be required to submit End-User Certificates (EUCs).</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Payment and Fees</strong>
          <ul>
            <li>The platform may charge transaction, listing fees, facilitation charge etc.</li>
            <li>Payments are processed through secure third-party gateways.</li>
            <li>Refunds and cancellations are subject to the Seller's policy and applicable law.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Confidentiality and Data Protection</strong>
          <ul>
            <li>All parties must maintain the confidentiality of sensitive information.</li>
            <li>The platform adheres to applicable data protection laws (e.g., GDPR, Indian IT Act).</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Prohibited Activities:</strong> Users may not:
          <ul>
            <li>List or purchase unauthorized or restricted items</li>
            <li>Misrepresent identity or credentials</li>
            <li>Attempt to breach platform security</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Intellectual Property</strong>
          <ul>
            <li>All content on the platform is protected by copyright and trademark laws.</li>
            <li>Users may not reproduce or distribute content without permission.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Limitation of Liability</strong>
          <ul>
            <li>The platform is not liable for any direct or indirect damages arising from transactions.</li>
            <li>Users transact at their own risk.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Termination</strong>
          <ul>
            <li>The platform may suspend or terminate accounts for violations of these terms.</li>
            <li>Users may terminate their account by written request.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Dispute Resolution</strong>
          <ul>
            <li>Disputes between Buyers and Sellers should first be addressed through the platform's mediation process.</li>
            <li>Unresolved disputes may be subject to arbitration under Indian or corresponding land law.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Modifications</strong>
          <ul>
            <li>The platform reserves the right to update these Terms at any time.</li>
            <li>Continued use of the platform constitutes acceptance of the revised terms.</li>
          </ul>
        </li>
      </ol>

      <h6 className="mt-4" style={{ fontSize: '16px' }}>Legal Terms and Conditions</h6>
      <p className="mb-4">These are essential clauses are to be abided in the marketplace's Terms and Conditions:</p>
      <ol className="mb-4">
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Contract Formation</strong>
          <ul>
            <li>A contract is formed when the Buyer accepts the Seller's offer by placing an order and the Seller confirms it in writing.</li>
            <li>All transactions are governed by the platform's Terms and Conditions, which override any conflicting terms proposed by either party.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Compliance with Laws:</strong> Both Buyer and Seller must comply with all applicable defense trade laws, including but not limited to:
          <ul>
            <li>Export Administration Regulations (EAR),</li>
            <li>International Traffic in Arms Regulations (ITAR), and</li>
            <li>Local arms control laws and embargoes.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Verification and Licensing</strong>
          <ul>
            <li>Sellers must provide valid licenses and certifications for all listed products.</li>
            <li>Buyers may be required to submit end-user certificates or government-issued procurement authorizations.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Indemnification and Defense</strong>
          <ul>
            <li>Sellers agree to defend and indemnify Buyers against third-party claims arising from defective products, IP infringement, or regulatory violations.</li>
            <li>Buyers must notify Sellers promptly of any such claims and cooperate in the defense process.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Confidentiality and Security</strong>
          <ul>
            <li>Both parties ie. the Buyer and the Seller must maintain the confidentiality of sensitive information.</li>
            <li>No party may disclose transaction details without prior written consent, except as required by law.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Dispute Resolution</strong>
          <ul>
            <li>Disputes will be resolved through arbitration or litigation in a mutually agreed jurisdiction.</li>
            <li>The platform may offer mediation services to resolve conflicts before legal escalation.</li>
          </ul>
        </li>
        <li className="mb-3" style={{ fontSize: '14px' }}>
          <strong>Termination and Suspension:</strong> The platform reserves the right to suspend or terminate accounts for violations of terms, including
          <ul>
            <li>Misrepresentation of products,</li>
            <li>Unauthorized sales and/or</li>
            <li>Breach of compliance obligations.</li>
          </ul>
        </li>
      </ol>
    </div>


  );
};

export default TermsConditions;